export default "__VITE_ASSET__qF0zr_Qi__"